(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1656],{

/***/ 90312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ChatAction */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85014);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5434);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["recieverType", "uniId"];







var ChatAction = function ChatAction(_ref) {
  var recieverType = _ref.recieverType,
      uniId = _ref.uniId,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();

  var connectChat = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(uniId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_1__/* ["default"].post */ .Z.post("/chat-service/add-user", {
                recieverId: parseInt(uniId),
                recieverType: recieverType !== null && recieverType !== void 0 ? recieverType : "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
                  var _res$data;

                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function connectChat(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_6___default().connect_wrapper), "  relative"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdOutlineQuestionAnswer */ .Iqb, {
        onClick: function onClick() {
          connectChat(uniId);
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "uni-tooltip",
        children: "Chat"
      })]
    });
  };

  if (true) {
    return renderComponent();
  } else {}
};
/* harmony default export */ __webpack_exports__["Z"] = (ChatAction);

/***/ }),

/***/ 10534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConversationAction */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15825);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(58735);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70754);
/* harmony import */ var _unisearch_common_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15603);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86893);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51649);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74231);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(25934);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72145);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["email"];















var ConversationAction = function ConversationAction(_ref) {
  var email = _ref.email,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, _excluded);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      conLoading = _useState[0],
      setConLoading = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false),
      conversationModal = _useState2[0],
      setConversationModal = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      conversationUniqueId = _useState3[0],
      setConversationUniqueId = _useState3[1]; // Validation schema


  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_6__/* .object */ .Ry().shape({
    email: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().email().required("Select an email"),
    message: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required("Write Message").typeError("Write Message"),
    subject: yup__WEBPACK_IMPORTED_MODULE_6__/* .string */ .Z_().required("Write something in subject box")
  });

  var handleClose = function handleClose(event, reason) {
    if (reason && reason == "backdropClick") return;
    setConversationModal(false);
  }; // draft mail


  var handleDraftMail = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              payload = {
                message: values.message,
                receiverEmail: values.email,
                subject: values.subject,
                parentMessageId: 0
              };

              if (!(values.subject && values.email)) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/draft/".concat(conversationUniqueId), payload).then(function (res) {
                if (!res.error) {}
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleDraftMail(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var storeMail = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setConLoading(true);
              payload = {
                message: values.message,
                receiverEmail: values.email,
                subject: values.subject,
                parentMessageId: 0
              };

              if (!(values.subject && values.email)) {
                _context4.next = 5;
                break;
              }

              _context4.next = 5;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/draft/".concat(conversationUniqueId), payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(res) {
                  var _payload;

                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!res.error && res.statusCode === 201)) {
                            _context3.next = 7;
                            break;
                          }

                          _payload = {
                            message: values.message,
                            receiverEmail: values.email,
                            subject: values.subject,
                            parentMessageId: 0
                          };
                          _context3.next = 4;
                          return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/student/conversation/conversation/send/".concat(conversationUniqueId), _payload).then( /*#__PURE__*/function () {
                            var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                              return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      if (!res.error) {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalSuccess */ .Xt)("Email Sent");
                                        setConLoading(false);
                                        setConversationModal(false);
                                      } else if (res.error && res.message) {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)(res.message);
                                        setConLoading(false);
                                      } else {
                                        (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)("something went wrong");
                                        setConLoading(false);
                                      }

                                    case 1:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x4) {
                              return _ref5.apply(this, arguments);
                            };
                          }());

                        case 4:
                          setConLoading(false);
                          _context3.next = 8;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_7__/* .swalError */ .Kj)(res.message);

                        case 8:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function storeMail(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().connect_wrapper), "  relative"),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_12__/* .IoMdMail */ .JwT, {
        onClick: function onClick() {
          setConversationModal(true);
          setConversationUniqueId((0,uuid__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)());
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        className: "uni-tooltip",
        children: "Conversation"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        open: conversationModal,
        onClose: handleClose,
        closeAfterTransition: true,
        BackdropComponent: _mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z,
        BackdropProps: {
          timeout: 500
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "modal md",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "modal_head",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h4", {
              className: "modal_title",
              children: "New Mail"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
              className: "cross_icon",
              onClick: function onClick() {
                setConversationModal(false);
                setConversationUniqueId();
              },
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_16__/* .FiX */ .q5L, {})
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
            className: "modal_body",
            style: {
              padding: "20px"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
              initialValues: {
                email: email,
                subject: "",
                message: "",
                parentMessageId: 0
              },
              enableReinitialize: true,
              validationSchema: validationSchema,
              onSubmit: function onSubmit(values) {
                storeMail(values);
              },
              children: function children(_ref6) {
                var handleSubmit = _ref6.handleSubmit,
                    setFieldValue = _ref6.setFieldValue,
                    values = _ref6.values,
                    errors = _ref6.errors,
                    touched = _ref6.touched;
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
                  className: "form",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "admin_drawer_container",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                      className: "admin_drawer_body_outer",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                        className: "admin_drawer_body",
                        style: {
                          height: "100%"
                        },
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                          className: (_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_wrapper),
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                            className: "reply_box",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                              className: (_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_to),
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
                                children: "To"
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                className: "reply_box_subject ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_subject)),
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                  className: "admin_form_group",
                                  style: {
                                    marginBottom: "0px"
                                  },
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("input", {
                                    style: {
                                      borderRadius: "0",
                                      border: "0"
                                    },
                                    type: "email",
                                    disabled: true,
                                    className: errors.email && touched.email ? "admin_input error_box" : "admin_input",
                                    placeholder: errors.email && touched.email ? errors.email : "Write a user email",
                                    onChange: function onChange(e) {
                                      handleChange(e.target.value);
                                      setFieldValue("email", e.target.value);
                                    },
                                    value: values.email ? values.email : ""
                                  })
                                })
                              })]
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                              className: "reply_box_subject ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().reply_box_subject)),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                                className: "admin_form_group",
                                style: {
                                  marginBottom: "0px"
                                },
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("input", {
                                  style: {
                                    borderRadius: "0",
                                    borderLeft: "0",
                                    borderRight: "0"
                                  },
                                  onBlur: function onBlur(e) {
                                    handleDraftMail(values);
                                  },
                                  type: "text",
                                  className: errors.subject && touched.subject ? "admin_input error_box" : "admin_input",
                                  placeholder: errors.subject && touched.subject ? errors.subject : "Write a subject line",
                                  onChange: function onChange(e) {
                                    setFieldValue("subject", e.target.value);
                                  },
                                  value: values.subject ? values.subject : ""
                                })
                              })
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                            className: "reply_box_texteditor",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_unisearch_common_form__WEBPACK_IMPORTED_MODULE_1__/* .UniEditorSmall */ .sk, {
                              onChange: function onChange(e) {
                                setFieldValue("message", e.target.value);
                              },
                              contents: values.message ? values.message : "",
                              onBlur: function onBlur(e) {
                                handleDraftMail(values);
                              }
                            })
                          })]
                        }), errors.message && touched.message && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                          className: "invalid-feedback",
                          children: errors.message
                        })]
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                    className: "modal_footer",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
                      className: "btn_group ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().btn_group)),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("button", {
                        className: "btn btn-cancel btn btn-md",
                        onClick: function onClick() {
                          setConversationModal(false);
                          setConversationUniqueId();
                        },
                        children: "Cancel"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
                        onClick: handleSubmit,
                        type: "submit",
                        className: "btn btn-secondary btn-md",
                        children: [conLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                          size: "16px",
                          color: "inherit"
                        }), "Send"]
                      })]
                    })
                  })]
                });
              }
            })
          })]
        })
      })]
    });
  };

  if (true) {
    return renderComponent();
  } else {}
};
/* harmony default export */ __webpack_exports__["Z"] = (ConversationAction);

/***/ }),

/***/ 53913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favourite_wrapper":"actions_favourite_wrapper__mmZgl","icon_heart":"actions_icon_heart__MtTT3","selected":"actions_selected__bf0TV","icon_swap":"actions_icon_swap__irRwk","compare_wrapper":"actions_compare_wrapper__z_sdX","bookmarke_wrapper":"actions_bookmarke_wrapper__31rzO","btn_bookmark":"actions_btn_bookmark__pq8QI","active":"actions_active__vtMRT","icon_spin":"actions_icon_spin__z5nco","spin":"actions_spin__kUes6","connect_wrapper":"actions_connect_wrapper__ESCJU","reply_box_wrapper":"actions_reply_box_wrapper__AVnAn","reply_box_to":"actions_reply_box_to__rmbnD","reply_box_subject":"actions_reply_box_subject__CBp2A","reply_box_actions":"actions_reply_box_actions__GBlrl","reply_box_action_right":"actions_reply_box_action_right__4oLns"};

/***/ })

}]);